import { createReducer, on } from '@ngrx/store';
import { ComponentInfoState, initialComponentInfoState } from './component-info.state';
import { ComponentInfoActions } from './component-info.actions';

export const componentInfoReducer = createReducer<ComponentInfoState>(
  initialComponentInfoState,
  on(ComponentInfoActions.loadComponentInfoSuccess, (state, { componentInfo }) => {
    return { ...state, componentInfo: componentInfo, error: undefined };
  }),
  on(ComponentInfoActions.loadComponentInfoError, (state, { error }) => {
    return { ...state, componentInfo: undefined, error: error };
  })
);
